import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap" }
const _hoisted_2 = { class: "col-12 xl:col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "grid ml-0 mr-1 mb-2" }
const _hoisted_5 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_6 = { class: "flex align-items-center flex-auto mt-1 ml-2 logo-filter-container" }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = { class: "flex align-items-center gap-4 mb-2" }
const _hoisted_9 = { class: "flex align-items-center gap-2" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "grid flex-nowrap" }
const _hoisted_12 = { class: "grid flex-nowrap hover-row align-items-center" }
const _hoisted_13 = { class: "col-fixed col-id" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "text-color-secondary"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "text-color-secondary"
}
const _hoisted_19 = {
  key: 3,
  class: "customer-sub-line text-color-secondary"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 4,
  class: "customer-sub-line text-color-secondary"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 5,
  class: "customer-sub-line text-color-secondary"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "col-fixed col-logo" }
const _hoisted_30 = ["src", "onClick"]
const _hoisted_31 = { class: "col-1 text-center" }
const _hoisted_32 = { class: "col-fixed col-actions text-right" }
const _hoisted_33 = { class: "sync-summary" }
const _hoisted_34 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_35 = { class: "flex flex-column align-items-center gap-3" }
const _hoisted_36 = { class: "logo-preview-container" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 0,
  class: "w-100pc"
}
const _hoisted_39 = {
  key: 1,
  class: "flex justify-content-between w-100pc"
}
const _hoisted_40 = { class: "flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[29] || (_cache[29] = _createElementVNode("h4", null, "Customer logos", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[19] || (_cache[19] = _createElementVNode("i", { class: "pi pi-users" }, null, -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.customerListFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customerListFilter) = $event)),
              placeholder: "Search customers..."
            }, null, 8, ["modelValue"]),
            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "pi pi-image" }, null, -1)),
            _createVNode(_component_Multiselect, {
              options: _ctx.logoOptions,
              searchable: true,
              filter: true,
              class: "w-100pc",
              modelValue: _ctx.logoFilter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.logoFilter) = $event)),
              valueProp: "customerLogoId",
              label: "logoName",
              "track-by": "logoName",
              placeholder: "Filter by logo..."
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportReport && _ctx.exportReport(...args))),
              class: "css-image excel-icon mt-1"
            }, null, 512), [
              [
                _directive_tooltip,
                'Export to Excel',
                void 0,
                { top: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.includeDeletedCustomers,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.includeDeletedCustomers) = $event)),
              onChange: _ctx.loadCustomers
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.includeDeletedCustomers = !_ctx.includeDeletedCustomers; _ctx.loadCustomers()})
            }, "Show deleted customers")
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_DataView, {
            value: _ctx.filteredCustomers,
            datakey: "companyId",
            paginator: true,
            rows: 10,
            scrollable: true,
            stripedRows: "",
            class: "p-datatable-sm",
            paginatorTemplate: _ctx.paginatorTemplate,
            rowsPerPageOptions: [10,20,50,100,200],
            responsiveLayout: "scroll",
            alwaysShowPaginator: false,
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "col-fixed col-id header-label sortable-header",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSort('companyId')))
                  }, [
                    _cache[22] || (_cache[22] = _createTextVNode(" Id ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIconFor('companyId'))
                    }, null, 2)
                  ]),
                  _createElementVNode("div", {
                    class: "col header-label sortable-header",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSort('companyName')))
                  }, [
                    _cache[23] || (_cache[23] = _createTextVNode(" Customer ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIconFor('companyName'))
                    }, null, 2)
                  ]),
                  _createElementVNode("div", {
                    class: "col-fixed col-logo header-label sortable-header",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSort('logoName')))
                  }, [
                    _cache[24] || (_cache[24] = _createTextVNode(" Logo (SVG only) ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIconFor('logoName'))
                    }, null, 2)
                  ]),
                  _createElementVNode("div", {
                    class: "col-1 header-label sortable-header text-center",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSort('displayCompassLogo')))
                  }, [
                    _cache[25] || (_cache[25] = _createTextVNode(" Show Compass logo ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIconFor('displayCompassLogo'))
                    }, null, 2)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-fixed col-actions text-right" }, null, -1))
                ])
              ])
            ]),
            list: _withCtx(({data}) => [
              _createElementVNode("div", {
                class: _normalizeClass({ 'col-12': true, 'row-deleted': data.isCompanyDeleted })
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (data.companyId && !data.isCompanyDeleted)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: [
                            _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(data.companyId)), ["exact"]),
                            _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(data.companyId, true)), ["shift"])
                          ]
                        }, _toDisplayString(data.companyId), 9, _hoisted_14))
                      : (data.companyId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(data.companyId), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (data.companyId && !data.isCompanyDeleted)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: [
                            _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(data.companyId)), ["exact"]),
                            _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(data.companyId, true)), ["shift"])
                          ]
                        }, _toDisplayString(data.companyName), 9, _hoisted_17))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(data.companyName), 1)),
                    (data.isCompanyDeleted)
                      ? (_openBlock(), _createBlock(_component_Badge, {
                          key: 2,
                          class: "small-grey-badge ml-1",
                          value: "deleted"
                        }))
                      : _createCommentVNode("", true),
                    (data.propertiesWithOverrideCount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createTextVNode(_toDisplayString(data.propertiesWithOverrideCount) + " propert" + _toDisplayString(data.propertiesWithOverrideCount === 1 ? 'y overrides' : 'ies override') + " this ", 1),
                          _createElementVNode("a", {
                            class: "ml-1",
                            onClick: ($event: any) => (_ctx.syncProperties(data))
                          }, "Sync all", 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true),
                    (data.ownPropertiesWithLogo && data.ownPropertiesWithLogo.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _cache[27] || (_cache[27] = _createTextVNode(" Bwof Template for ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLogoRefs(data.ownPropertiesWithLogo, data.companyId, 'own'), (property, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: property.id
                            }, [
                              _createElementVNode("a", {
                                onClick: [
                                  _withModifiers(($event: any) => (_ctx.navigation.toPropertyDetailsScreen(property.id)), ["exact"]),
                                  _withModifiers(($event: any) => (_ctx.navigation.toPropertyDetailsScreen(property.id, true)), ["shift"])
                                ]
                              }, _toDisplayString(property.name), 9, _hoisted_22),
                              (index < _ctx.visibleLogoRefs(data.ownPropertiesWithLogo, data.companyId, 'own').length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, ", "))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (!_ctx.isLogoListExpanded(data.companyId, 'own') && data.ownPropertiesWithLogo.length > _ctx.inlineLogoListLimit)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.expandLogoList(data.companyId, 'own'))
                              }, "...", 8, _hoisted_24))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (data.sharedWith && data.sharedWith.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _cache[28] || (_cache[28] = _createTextVNode(" Also Bwof Template for ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLogoRefs(data.sharedWith, data.companyId, 'shared'), (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: (item.isProperty ? 'p' : 'c') + item.id
                            }, [
                              _createElementVNode("a", {
                                onClick: [
                                  _withModifiers(($event: any) => (item.isProperty ? _ctx.navigation.toPropertyDetailsScreen(item.id) : _ctx.navigation.toCompanyDetailsScreen(item.id)), ["exact"]),
                                  _withModifiers(($event: any) => (item.isProperty ? _ctx.navigation.toPropertyDetailsScreen(item.id, true) : _ctx.navigation.toCompanyDetailsScreen(item.id, true)), ["shift"])
                                ]
                              }, _toDisplayString(item.name), 9, _hoisted_26),
                              (index < _ctx.visibleLogoRefs(data.sharedWith, data.companyId, 'shared').length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, ", "))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (!_ctx.isLogoListExpanded(data.companyId, 'shared') && data.sharedWith.length > _ctx.inlineLogoListLimit)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.expandLogoList(data.companyId, 'shared'))
                              }, "...", 8, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (data.bwofTemplateLogo)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreviewSrc(data),
                          class: "logo-thumbnail cursor-pointer",
                          onClick: ($event: any) => (_ctx.openManageLogo(data))
                        }, null, 8, _hoisted_30)), [
                          [
                            _directive_tooltip,
                            'Manage this logo',
                            void 0,
                            { top: true }
                          ]
                        ])
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openCompassLogoPreview && _ctx.openCompassLogoPreview(...args)))
                        }, "Compass default"))
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                      _createVNode(_component_InputSwitch, {
                        disabled: !_ctx.canSetDisplayCompassLogo(data),
                        modelValue: data.displayCompassLogo,
                        "onUpdate:modelValue": ($event: any) => ((data.displayCompassLogo) = $event),
                        onChange: ($event: any) => (_ctx.setDisplayCompassLogo(data))
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                    ])), [
                      [
                        _directive_tooltip,
                        _ctx.displayCompassLogoTooltip(data),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (data.companyId)
                      ? (_openBlock(), _createBlock(_component_SplitButton, {
                          key: 0,
                          label: data.bwofTemplateLogo ? 'Update' : 'Upload',
                          icon: "pi pi-upload",
                          class: "p-button-sm",
                          model: _ctx.uploadMenuItemsFor(data),
                          onClick: ($event: any) => (_ctx.chooseFile(data))
                        }, null, 8, ["label", "model", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["value", "paginatorTemplate"])
        ])
      ])
    ]),
    _createElementVNode("input", {
      type: "file",
      ref: "fileInput",
      accept: ".svg",
      class: "hidden",
      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
    }, null, 544),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSyncConfirm,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showSyncConfirm) = $event)),
      modal: true,
      header: "Sync properties",
      class: "confirm-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "cancel",
          onClick: _ctx.cancelSyncConfirm
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Continue",
          icon: "pi pi-check",
          onClick: _ctx.confirmSync
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.syncAffectedProperties.length) + " propert" + _toDisplayString(_ctx.syncAffectedProperties.length === 1 ? 'y' : 'ies') + " will be updated to use " + _toDisplayString(_ctx.syncCustomer ? _ctx.syncCustomer.companyName : 'this customer') + "'s logo, including ", 1),
        (_ctx.syncAffectedProperties.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
              _cache[30] || (_cache[30] = _createElementVNode("b", null, "View all:", -1)),
              _cache[31] || (_cache[31] = _createTextVNode()),
              _withDirectives(_createElementVNode("a", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.exportSyncAffectedProperties && _ctx.exportSyncAffectedProperties(...args))),
                class: "css-image excel-icon"
              }, null, 512), [
                [
                  _directive_tooltip,
                  'Export full list to Excel',
                  void 0,
                  { top: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[32] || (_cache[32] = _createElementVNode("p", null, "Continue?", -1))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSelectExisting,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showSelectExisting) = $event)),
      modal: true,
      header: "Update logo",
      class: "confirm-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "cancel",
          onClick: _ctx.cancelSelectExisting
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Assign",
          disabled: !_ctx.selectExistingLogoId,
          onClick: _ctx.confirmSelectExisting
        }, null, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, "Assign an existing logo to " + _toDisplayString(_ctx.selectExistingCustomer ? _ctx.selectExistingCustomer.companyName : 'this customer') + ".", 1),
        _createVNode(_component_Multiselect, {
          options: _ctx.logoOptions,
          searchable: true,
          filter: true,
          class: "w-100pc",
          modelValue: _ctx.selectExistingLogoId,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectExistingLogoId) = $event)),
          valueProp: "customerLogoId",
          label: "logoName",
          "track-by": "logoName",
          placeholder: "Choose a logo..."
        }, null, 8, ["options", "modelValue"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      class: "manage-logo-popup",
      visible: _ctx.showManageLogoPopup,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showManageLogoPopup) = $event)),
      modal: true,
      header: "Manage logo"
    }, {
      footer: _withCtx(() => [
        (_ctx.isCompassDefaultLogo)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Close",
              icon: "pi pi-check",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showManageLogoPopup = false))
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createVNode(_component_Button, {
                label: "Delete",
                icon: "pi pi-trash",
                class: "p-button-danger",
                onClick: _ctx.deleteFromManagePopup
              }, null, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_Button, {
                  label: "Cancel",
                  icon: "pi pi-times",
                  class: "cancel",
                  onClick: _ctx.cancelManageLogo
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Save",
                  icon: "pi pi-save",
                  onClick: _ctx.saveManageLogo
                }, null, 8, ["onClick"])
              ])
            ]))
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("img", {
              src: _ctx.manageLogoPreviewSrc,
              class: "logo-preview-image"
            }, null, 8, _hoisted_37),
            (!_ctx.isCompassDefaultLogo && _ctx.manageCustomer && _ctx.manageCustomer.companyId)
              ? _withDirectives((_openBlock(), _createBlock(_component_SplitButton, {
                  key: 0,
                  icon: "pi pi-upload",
                  class: "logo-upload-overlay",
                  model: _ctx.manageLogoUploadMenuItems(),
                  onClick: _ctx.chooseManageFile
                }, null, 8, ["model", "onClick"])), [
                  [
                    _directive_tooltip,
                    'Update image',
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isCompassDefaultLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _cache[33] || (_cache[33] = _createElementVNode("label", null, "Logo name", -1)),
                _createVNode(_component_InputText, {
                  modelValue: _ctx.manageLogoName,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.manageLogoName) = $event)),
                  class: "w-100pc"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("input", {
      type: "file",
      ref: "manageFileInput",
      accept: ".svg",
      class: "hidden",
      onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onManageFileSelected && _ctx.onManageFileSelected(...args)))
    }, null, 544)
  ]))
}